module.exports = __webpack_public_path__ + "static/media/ABBLogo.f6fe3974.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ABBLogo.svg
// module id = 98
// module chunks = 0